export default __webpack_public_path__ + "static/media/voucherAddition4.aabcb134.jpg";